import Image from 'next/image'
import styles from './HowItWorksHero.module.scss'
import howItWorksBg from '../public/images/how-it-works-bg.jpg'
import Container from 'react-bootstrap/Container'

export default function HowItWorksHero() {
  return (
    <div className={`${styles.heroContainer} `}>
      <div className={styles.overlay}></div>

      <Image
        src={howItWorksBg}
        className={styles.backgroundImage}
        alt="Cover photo"
        priority
        fill
        sizes="100vw"
        style={{
          objectFit: "cover",
          objectPosition: "center"
        }} />

      <Container className={`${styles.content} d-flex h-100`}>
        <div className="text-white text-center my-auto w-100">
          <h1 className="my-5">Find the Perfect Tutor in Minutes</h1>
        </div>
      </Container>
    </div>
  )
}
